export default __webpack_public_path__ + "static/media/checks-green.622fccfa.svg";